import {
  Container,
  Description,
  Explanation,
  Title,
  Wrapper,
  Button,
  ButtonGroup,
  CookieModal as CookieModalStyled,
} from "./CookieModal.styles";
import { updateConsent } from "utils/GoogleTagManager/GoogleTagManager";

interface CookieModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const CookieModal: React.FC<CookieModalProps> = ({
  isOpen,
  onClose,
}) => {
  const handleAccept = () => {
    updateConsent(true);
    onClose();
  };

  const handleReject = () => {
    updateConsent(false);
    onClose();
  };

  return (
    <CookieModalStyled
      open={isOpen}
      onClose={onClose}
      aria-labelledby="cookie-modal-title"
      aria-describedby="cookie-modal-description"
    >
      <Wrapper>
        <Container>
          <Title id="cookie-modal-title">Cookies on our website</Title>
          <Description id="cookie-modal-description">
            We use cookies to provide visitors with the best possible experience
            on our websites. These include performance and analytics cookies to
            improve and customise your browsing experience. These cookies don't
            collect any identifiable information, are aggregated and therefore
            anonymous. See our{" "}
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://www.unum.co.uk/how-we-use-cookies"
            >
              How we use cookies
            </a>{" "}
            page for more information.
          </Description>
          <Explanation>
            By clicking ‘Accept all cookies’, you agree to the storing of
            cookies on your device to enhance site navigation, analyse site
            usage and help us in our marketing.
          </Explanation>
          <ButtonGroup>
            <Button option="Reject" onClick={handleReject}>
              Decline
            </Button>
            <Button option="Agree" onClick={handleAccept}>
              Accept
            </Button>
          </ButtonGroup>
        </Container>
      </Wrapper>
    </CookieModalStyled>
  );
};

export default CookieModal;
